import { MONTH_DAY_NAME_FORMAT, NewsLevelEnum } from '@doltech/utils/lib/constants';
import { formatDate } from '@doltech/utils/lib/date';
import * as React from 'react';
import styled from 'styled-components';

import { Box } from '../../Common/BoxV2';
import { Typography } from '../../DesignSystemV2/Typography';
import cl from 'classnames';
import { BlogSocialButton } from '../../Layout/Landing/SocialButton/BlogSocialButton';
import { Grid } from 'styled-css-grid';
import { TagNews } from '../ui/TagNews/TagNews';

interface NewsExtraInfoProps {
  topic?: any;
  createdAt?: any;
  level?: string;
  seoData?: any;
}

const NewsExtraInfoMain = styled(Box)`
  display: grid;
  grid-auto-columns: max-content;
  grid-auto-flow: column;
  gap: 4px;
  align-items: center;
`;
const GridWrapper = styled(Grid)`
  grid-template-columns: auto max-content;
  @media (max-width: 399px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto max-content;
  }
`;
export const NewsExtraInfo = ({ topic, createdAt, level, seoData }: NewsExtraInfoProps) => {
  const { levelText, newslevel } = React.useMemo(() => {
    switch (level) {
      case NewsLevelEnum.BASIC: {
        return { newslevel: 'basic', levelText: 'Basic' };
      }
      case NewsLevelEnum.INTERMEDIATE: {
        return {
          newslevel: 'intermediate',
          levelText: 'Intermediate',
        };
      }
      case NewsLevelEnum.ADVANCED:
      default: {
        return {
          newslevel: 'advanced',
          levelText: 'Advanced',
        };
      }
    }
  }, [level]);

  return (
    <GridWrapper columns="auto max-content">
      <NewsExtraInfoMain className="extra-info-container">
        {levelText && <TagNews type={newslevel as any} text={levelText} />}

        {topic?.name && <TagNews type="field" text={topic?.name || ''} />}

        {createdAt && (
          <Typography.Paragraph className="created-at" color="black70" variant="semi-bold/14">
            {formatDate(createdAt, MONTH_DAY_NAME_FORMAT)}
          </Typography.Paragraph>
        )}
      </NewsExtraInfoMain>
      <div className={cl('social-buttons-wrapper')}>
        {seoData && (
          <BlogSocialButton
            align="horizontal"
            actions={['copy-link', 'facebook', 'clap']}
            showText={false}
            seoData={
              seoData || {
                id: 'preview',
                url: '/',
              }
            }
            pageData={null}
          />
        )}
      </div>
    </GridWrapper>
  );
};
